export const AUTH0_CACHE_LOCATION = 'localstorage';
export const AUTH0_USE_REFRESH_TOKENS = true;
export const AUTH0_USE_REFRESH_TOKENS_FALLBACK = true;
